import types from './types';

function dataSolicitationReducer(state, action) {
  switch(action.type) {
    case types.SET_CREDIT:
      return {...state, credit: action.credit }
    case types.SET_LAST_CREDIT:
      return {...state, lastCredit: action.lastCredit }
    case types.SET_SOLICITATION:
      return {...state, solicitation: action.solicitation }
    case types.SET_BASIC_DATA:
      return {...state, basicData: action.basicData }
    case types.SET_EDUCATIONAL_LEVEL:
      return {...state, basicData: {...state.basicData, educationalLevel: action.educationalLevel}}
    case types.SET_ESTRATO:
      return {...state, basicData: {...state.basicData, estrato: action.estrato}}
    case types.SET_ID_ASESOR:
      return {...state, basicData: {...state.basicData, idAsesor: action.idAsesor}}
    case types.SET_TIPO_CONTRATO:
      return {...state, basicData: {...state.basicData, tipoContrato: action.tipoContrato}}
    case types.SET_EDAD:
        return {...state, basicData: {...state.basicData, edad: action.edad}}
    case types.SET_BASIC_DATA_MARITAL_STATUS:
      return {...state, basicData: {...state.basicData, estadoCivil: action.estadoCivil}}
    case types.SET_CREDIT_LINE:
      return {...state, creditData: {...state.creditData, lineaCredito: action.lineaCredito}}
    case types.SET_CREDIT_CHECKBOX:
      return {...state, creditData: {...state.creditData, credits: action.credits}}
    case types.ADD_FIELD:
      return {...state, creditData: {...state.creditData, fields: [...state.creditData.fields, action.field]}}
    case types.SET_FIELDS:
      return {...state, creditData: {...state.creditData, fields: action.fields}}
    case types.SET_CREDIT_DATA:
      return {...state, creditData: action.creditData}
    case types.SET_DEFAULT_INPUT:
      return {...state, creditData: {...state.creditData, fields: action.fields}}
    case types.SET_WORK_DATA_DOCUMENT_TYPE:
      return {...state, workData: {...state.workData, tipoDocumento: action.tipoDocumento}}
    case types.SET_WORK_CERTIFICATION:
      return {...state, workData: {...state.workData, certificacionLaboral: [action.file[0]]}}
    case types.REMOVE_WORK_CERTIFICATION_FILE:
      return {...state, workData: {...state.workData, certificacionLaboral: []}}
    case types.SET_WORK_DATA:
      return {...state, workData: action.workData}
    case types.SET_BRANCH:
      return {...state, workData: {...state.workData, branch: action.branch}}
    case types.SET_COMPLEMENT_DATA_IDENTIFICATION_TYPE:
      return {...state, complementData: {...state.complementData, idTipo: action.idTipo}}
    case types.SET_SEGMENT:
      return {...state, complementData: {...state.complementData, segmento: action.segmento}}
    case types.SET_COMPLEMENT_DATA:
      return {...state, complementData: action.complementData}
    case types.SET_ADITIONAL_DATA:
      return {...state, aditionalData: action.aditionalData}
    case types.SET_ADITIONAL_DATA_SELECTED_CITY:
      return {...state, aditionalData: {...state.aditionalData, ciudad: action.city}}
    case types.SET_ADITIONAL_DATA_SELECTED_STATE:
      return {...state, aditionalData: {...state.aditionalData, departamento: action.state}}
    case types.SET_SELECTED_EXTRA_CITY:
      return {...state, aditionalData: {...state.aditionalData, extraCiudad: action.city}}
    case types.SET_SELECTED_EXTRA_STATE:
      return {...state, aditionalData: {...state.aditionalData, extraDepartamento: action.state}}
    case types.SET_EXTRACT:
      return {...state, aditionalData: {...state.aditionalData, estrato: action.estrato}}
    case types.SET_OWN_VEHICLE:
      return {...state, aditionalData: {...state.aditionalData, tieneVehiculo: action.tieneVehiculo}}
    case types.SET_CORRESPONDENCE:
      return {...state, aditionalData: {...state.aditionalData, correspondencia: action.correspondencia}}
    case types.SET_COMPLEMENT_DATA_SELECTED_CITY:
      return {...state, complementData: {...state.complementData, ciudad: action.ciudad}}
    case types.SET_COMPLEMENT_DATA_SELECTED_STATE:
      return {...state, complementData: {...state.complementData, pagaduria: action.pagaduria}}
    case types.SET_COMPLEMENT_DATA_ACTIVITIE:
      return {...state, complementData: {...state.complementData, actividad: action.actividad}}
    case types.SET_CLIENT:
      return {...state, client: action.client }
    case types.SET_PAYMENT_BILL:
      return {...state, solicitation: { ...state.solicitation, pagaduria: action.pagaduria }}
    case types.SET_RATE:
      return {...state, creditData: { ...state.creditData, tasa: state.tasa }}
    case types.SET_PRODUCT:
        return {...state, creditData: {...state.creditData, pricingProduct: action.pricingProduct}}
    case types.SET_TASA:
      return {...state, creditData: {...state.creditData, pricingProduct: {...state.creditData.pricingProduct, rate: action.rate}}}
    case types.SET_PAIS_NACIMIENTO:
        return {...state,solicitation: {...state.solicitation,cliente: { ...state.solicitation.cliente, paisNacimiento2: action.paisNacimiento2 }}}
    case types.SET_SELECTED_CITY:
        return {...state,solicitation: {...state.solicitation,cliente: { ...state.solicitation.cliente, lugarNacimiento2: action.lugarNacimiento2 }}}
    case types.SET_ACTIVITIE:
        return {...state, basicData: {...state.basicData, actividadCliente: action.actividadCliente}}
    case types.SET_ACTIVITIE_CREDIT:
        return {...state, credit: {...state.credit, actividadCliente: action.actividadCliente}}
    case types.SET_PRICING:
        return {...state, pricing: action.pricing}
    case types.SET_SELECT_ETHNIC_GROUP:
        return {...state, basicData: {...state.basicData, grupoEtnico: action.grupoEtnico}}  
    case types.SET_SELECTED_GENDER:
        return {...state,solicitation: {...state.solicitation,cliente: { ...state.solicitation.cliente, genero: action.genero }}}
    case types.SET_BASIC_DATA_SPECIAL_CONDITION:
        return {...state, basicData: {...state.basicData, condicionEspecial: action.condicionEspecial}}  
    case types.SET_DESTINO_CREDITO:
        return {...state, basicData: {...state.basicData, destinoCredito: action.destinoCredito}}
    default:
      return state;
  }
}

export default dataSolicitationReducer;
